"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _newbuildingPromo = require("../constants/newbuildingPromo");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useQueryManager = _ref => {
  let {
    fetchData,
    ids,
    fetchStep,
    currentIndex,
    mobile
  } = _ref;
  const [items, setItems] = React.useState([]);
  React.useEffect(() => {
    setItems(ids.map(id => _objectSpread(_objectSpread({}, _newbuildingPromo.newbuildingPromoScheme), {}, {
      id
    })));
  }, [ids]);
  React.useEffect(() => {
    const getPayload = () => {
      return items.slice(currentIndex, currentIndex + fetchStep).filter(item => !item.isLoaded).map(item => item.id);
    };
    const setData = data => {
      setItems(items.map(item => data.find(fetchedItem => fetchedItem.id === item.id) || item));
    };
    const fetchNewbuildingData = async () => {
      const payload = getPayload();
      const ignoreLoad = mobile && payload.length < Math.ceil(fetchStep / 2) && items.length - currentIndex > fetchStep;
      if (!payload.length || ignoreLoad) {
        return;
      }
      const data = await fetchData(payload);
      if (!Array.isArray(data) || data.length === 0) {
        return;
      }
      const dataIds = data.map(item => item.id);
      const fetchedIds = items.filter(item => item.isLoaded).map(item => item.id);
      const isFetchedData = dataIds.some(id => fetchedIds.includes(id));
      if (isFetchedData) {
        return;
      }
      setData(data);
    };
    fetchNewbuildingData();
  }, [fetchData, fetchStep, currentIndex, items, mobile]);
  return {
    items
  };
};
exports.useQueryManager = useQueryManager;